import { keyframes } from '@components-shared/src/stitches';

export const bubble = keyframes({
  '0%': {
    opacity: 0,
  },
  '100%': {
    opacity: 1,
  },
});
